import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const NooksModal = (props) => {
    const {user} = useAppContext();
    const {provider, toggle} = props;
    const [apiKey, setApiKey] = useState("");
    const [errorApiKey, setErrorApiKey] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        if (!apiKey || apiKey.trim() === "") {
            setErrorApiKey(true);
            return;
        }

        setLoading(true);
        let provider :any = {
            accessToken: apiKey.trim(),
            provider: "nooks",
            service: "Dialer",
        }

        try {
            let response = await postJsonAxiosService("nooks/webhook/validate", {provider: provider});
            if (response && response.data && response.data.success) {
                if (!user.providers || user.providers.length == 0) {
                    user.providers = [];
                }
                provider.status = "Installed"
                provider.providerId = response.data.userId;
                user.providers.push(provider);
                toastService.info("Nooks Integrated Successfully!");
                props.toggle();
                setTimeout(() => window.location.reload(), 1000);
            } else {
                toastService.error("Failed to validate Nooks API Key");
            }
        } catch (e: any) {
            const errorMessage = e.response?.data || "Invalid API Key or unable to connect to Nooks";
            toastService.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Nooks Dialer Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124", marginBottom: 15}}>
                        <label style={{fontWeight: 500, marginBottom: 8, display: "block"}}>Nooks API Key</label>
                        <Input
                            style={{fontSize: 14, color: "#202124"}}
                            placeholder="Enter your Nooks API Key"
                            value={apiKey}
                            type="password"
                            onChange={(e) => {
                                setApiKey(e.target.value);
                                setErrorApiKey(false);
                            }}
                        />
                        {errorApiKey ? (
                            <div className="snippet-desc-error" style={{color: "red", marginTop: 5}}>
                                Please enter your Nooks API Key
                            </div>
                        ) : null}
                    </div>
                    <div style={{fontSize: 13, color: "#5f6368", marginTop: 10}}>
                        <p style={{marginBottom: 5}}>To get your API Key:</p>
                        <ol style={{paddingLeft: 20, margin: 0}}>
                            <li>Log in to your Nooks account</li>
                            <li>Go to Settings → Integrations → API</li>
                            <li>Generate or copy your API Key</li>
                        </ol>
                        <p style={{marginTop: 10, fontStyle: "italic"}}>
                            Note: Each team member should add their own API Key to ensure calls are tracked correctly.
                        </p>
                    </div>
                </div>

            </ModalBody>
            <ModalFooter style={{border: "none", padding: "0px 0px 10px 30px"}}>
                <Button className={"btn-typography-secondary"} onClick={props.toggle} disabled={loading}>
                    Cancel
                </Button>{" "}
                <Button className={"btn-typography-primary"} onClick={handleSubmit} disabled={loading}>
                    {loading ? "Validating..." : "Connect"}
                </Button>{" "}
            </ModalFooter>
        </div>
    )
};

export default NooksModal;
